export type UserStatusState = {
  recoveryTimeEndsAt?: number | null;
  refreshUserStatusLoading: boolean;
};

export enum UserStatusEventType {
  USER_STATUS_UPDATED_AVAILABLE = 'userStatus.updated.available',
  USER_STATUS_STUCK = 'userStatus.stuck',
}
